import { createSelector } from "reselect";
import i18n from "~/i18n";
import { sortCompare } from "~/utils/utils";

export const getProjectCategories = (state) => state.projectCategories;

export const getProjectCategoriesArray = createSelector(getProjectCategories, (categories) =>
  Object.values(categories)
);

export const getProjectCategoriesByIds = createSelector(
  getProjectCategories,
  (_state, ids) => ids,
  (categories, ids) => {
    const projectCategories = ids
      .map((id) => {
        return categories[id];
      })
      .filter(Boolean)
      .sort((a, b) => sortCompare(a.name.toLowerCase(), b.name.toLowerCase()));

    return ids.includes(0) ? [{ id: 0, name: i18n.t("No category") }, ...projectCategories] : projectCategories;
  }
);

export const getProjectCategoryById = createSelector(
  getProjectCategories,
  (state, id) => id,
  (categories, id) => {
    const category = categories[id];
    if (category) {
      return category;
    }
  }
);
